module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/q01_1_sp_ab9f9905a75aff20388862887d75b95e.png";